<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                :dropdown-match-select-width="false"
                :value.sync="queryParams.organizationCodeList"
                selectType="selectMultiple"
                :selectData="inventOrg"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
              <!-- <global-select
                :value.sync="queryParams.organizationCodeList"
                selectType="selectMultiple"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 102 }"
              /> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单号">
              <global-select
                :value.sync="queryParams.wipEntityIdList"
                selectType="selectMultipleSearch"
                requestApi="/scp/scpMrpWipJobKitting/wipEntityNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ orgList: queryParams.organizationCodeList }"
                searchParam="wipEntityName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划开始时间" :labelCol="{ style: { width: '90px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.createTimeList, 'YYYY-MM-DD') }}</template>
                <a-range-picker v-model="queryParams.createTimeList" allowClear />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="装配件-物料编码" v-if="advanced">
              <global-select
                :value.sync="queryParams.itemIdList"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="库存齐套状态" :labelCol="{ style: { width: '90px' } }">
              <global-select
                :value.sync="queryParams.onhandKittingStatus"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_KITTING_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="扩展齐套状态" :labelCol="{ style: { width: '90px' } }">
              <global-select
                :value.sync="queryParams.extendKittingStatus"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_KITTING_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '120px' } }">
          <a-row class="align-center">
            <download-modal :apiFun="apiScpMrpWipJobKittingNewExport" ref="download" />
            <a-button type="primary" @click="handleExport" v-hasPermi="['scp:scpMrpWipJobKitting:export']">导出</a-button>
            <a-col :md="7" :sm="24" class="ml20">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="齐套分析完成时间">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :scroll="{ x: tableX, fixScreen: true }"
          @successCallBack="successCallBack"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.WORK_ORDER_SET_REPORT_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a @click="goNextPage(record)">物料明细</a>
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpWipJobKittingList,
  apiScpMrpWipJobKittingNewExport,
  apiScpMrpPlansKittingExecutionTime
} from '@/api/scp/workOrderSetCall/workOrderSetReport'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  name: 'WorkOrderSetReport',
  components: { DownloadModal },
  data () {
    return {
      apiScpMrpWipJobKittingNewExport,
      isEdit: false,
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpWipJobKittingList, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        organizationCodeList: undefined,
        wipEntityIdList: undefined,
        createTimeList: undefined,
        staScheduleDate: undefined,
        endScheduleDate: undefined,
        itemIdList: undefined,
        onhandKittingStatus: undefined,
        extendKittingStatus: undefined
      },
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2500,
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 120,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'orderNo',
          align: 'center',
          width: 150,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '装配件-物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          ellipsis: true
        },
        {
          title: '装配件-物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '计划数量',
          dataIndex: 'startQuantity',
          align: 'center',
          ellipsis: true
        },
        {
          title: '库存齐套状态',
          dataIndex: 'onhandKittingStatusName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '扩展齐套状态',
          dataIndex: 'extendKittingStatusName',
          align: 'center',
          ellipsis: true
        },
        // {
        //   title: 'JIT齐套状态',
        //   dataIndex: 'jitKittingStatusName',
        //   align: 'center',
        //   ellipsis: true
        // },
        {
          title: '库存缺料物料数',
          dataIndex: 'onhandShortageItems',
          align: 'center',
          ellipsis: true
        },
        {
          title: '扩展缺料物料数',
          dataIndex: 'extendShortageItems',
          align: 'center',
          ellipsis: true
        },
        // {
        //   title: 'JIT缺料物料数',
        //   dataIndex: 'jitShortageItems',
        //   align: 'center',
        //   ellipsis: true
        // },
        {
          title: '已完成',
          dataIndex: 'quantityCompleted',
          align: 'center',
          ellipsis: true
        },
        {
          title: '剩余数量',
          dataIndex: 'quantityRemaining',
          align: 'center',
          ellipsis: true
        },
        {
          title: '计划开始时间',
          dataIndex: 'scheduleStartDate',
          scopedSlots: { customRender: 'scheduleStartDate' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "" // 齐套分析完成时间
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  watch: {
    "queryParams.createTimeList" (newVal, oldVal) {
      this.queryParams.staScheduleDate = newVal[0] && `${this.$moment(newVal[0]).format('YYYY-MM-DD')} 00:00:00`
      this.queryParams.endScheduleDate = newVal[1] && `${this.$moment(newVal[1]).format('YYYY-MM-DD')} 23:59:59`
      this.$refs.dataTable.searchParams = this.queryParams;
    }
  },
  created () {},
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.getTableTime()
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    successCallBack (myDataSource) {},
    // 跳转物料
    goNextPage (record) {
      this.$router.push({ name: "MaterialSetReport", query: { data: JSON.stringify(record) } })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCodeList: undefined,
        wipEntityIdList: undefined,
        createTimeList: undefined,
        staScheduleDate: undefined,
        endScheduleDate: undefined,
        itemIdList: undefined,
        onhandKittingStatus: undefined,
        extendKittingStatus: undefined
      }
      this.tableList = []
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('scp/scpMrpWipJobKitting/export', {
      //   ...this.queryParams
      // }, `工单齐套报表_${new Date().getTime()}.xlsx`)
    },
    getTableTime () {
      // 数据收集时间、齐套分析完成时间
      apiScpMrpPlansKittingExecutionTime(this.queryParams).then(res => {
        if (res.data) {
          this.dataCollectStartDate = this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.planCompletionDate = this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.plan-time{
  font-weight: bold;
}
</style>
